"use client";
import { urls } from "../urls/Urls";

const CommonRequest = () => {
  return (
    <>
      <div>
        <p className="text-3xl flex text-gray-800 font-medium justify-center">
          Common Requests
        </p>
      </div>
      <div className="flex flex-col md:flex-row gap-8 py-4 items-center justify-center text-gray-800">
        {/* Find an employee */}
        <a
          href={urls.people}
          target="_blank"
          rel="noreferrer"
          className="h-24 border min-w-60 border-gray-200 bg-white hover:shadow-md hover:bg-gray-100 hover:border-gray-400 py-6 flex max-w-60 rounded drop-shadow"
        >
          <div className="flex items-center justify-center">
            <img
              src={"/search.png"}
              height={80}
              width={80}
              className="p-2 px-3"
              alt="facilities"
            />
          </div>
          <div className="pt-3">
            <h2 className="text-base">Find an Employee</h2>
          </div>
        </a>

        {/* GC Reserve */}
        <a
          href={urls.reserve}
          target="_blank"
          rel="noreferrer"
          className="h-24 min-w-60 border border-gray-200 bg-white hover:shadow-md hover:bg-gray-100 hover:border-gray-400 py-6 flex max-w-60 rounded drop-shadow"
        >
          <div className="flex items-center justify-center">
            <img
              src={"/reserve.png"}
              height={80}
              width={80}
              className="p-2 px-3"
              alt="facilities"
            />
          </div>
          <div className="pt-3">
            <h2 className="text-base">GC Reserve</h2>
          </div>
          <br />
        </a>

        {/* Travel notification */}
        <a
          href={urls.travel}
          target="_blank"
          rel="noreferrer"
          className="h-24 min-w-60 border border-gray-200 bg-white hover:shadow-md hover:bg-gray-100 hover:border-gray-400 py-3 flex max-w-60 rounded drop-shadow"
        >
          <div className="flex items-center justify-center">
            <img
              src={"/travel.png"}
              height={200}
              width={200}
              className="p-2 px-3"
              alt="travel"
            />
          </div>
          <div className="pr-4">
            <h2 className="text-base">International Travel Cybersecurity Notification</h2>
          </div>
        </a>

        {/* Teams/Sharepoint site */}
        <a
          href={urls.site}
          target="_blank"
          rel="noreferrer"
          className="h-24 min-w-60 border border-gray-200 bg-white hover:shadow-md hover:bg-gray-100 hover:border-gray-400 py-6 flex max-w-60 rounded drop-shadow"
        >
          <div className="flex items-center justify-center">
            <img
              src={"/site.png"}
              height={120}
              width={120}
              className="p-2 px-3"
              alt="facilities"
            />
          </div>
          <div className="">
            <h2 className="text-base">New Teams/ SharePoint Site</h2>
          </div>
        </a>

        {/* Teams recording */}
        <a
          href={urls.teamrec}
          target="_blank"
          rel="noreferrer"
          className="h-24 min-w-60 border border-gray-200 bg-white hover:shadow-md hover:bg-gray-100 hover:border-gray-400 py-6 flex max-w-60 rounded drop-shadow"
        >
          <div className="flex items-center justify-center">
            <img
              src={"/mic.png"}
              height={100}
              width={100}
              className="p-2 px-3"
              alt="facilities"
            />
          </div>
          <div className="">
            <h2 className="text-base">Request Teams Recording</h2>
          </div>
        </a>
      </div>
    </>
  );
};

export default CommonRequest;
